export function cronParser(schedule: string) {
  let frequency: string | undefined = undefined;
  let day: string | undefined = undefined;
  let hour: string | undefined = undefined;
  let hourInterval: string | undefined = undefined;
  let minuteInterval: string | undefined = undefined;
  let description: string | undefined = undefined;

  if (schedule) {
    const scheduleChars = schedule.split(' ');

    if (scheduleChars[4] !== '*') {
      frequency = 'w';
    } else if (scheduleChars[1].indexOf('/') > -1 || schedule === '0 * * * *') {
      frequency = 'd';
    } else if (scheduleChars[0].indexOf('/') > -1 || schedule === '* * * * *') {
      frequency = 's';
    } else {
      frequency = 'm';
    }

    if (frequency === 'm') {
      day = scheduleChars[2];
      hour = scheduleChars[1];
      description = `Her ayın ${day}. günü saat ${hour.padStart(2, '0')}:00`;
    } else if (frequency === 'w') {
      day = scheduleChars[4];
      hour = scheduleChars[1];
      description = `Her haftanın ${day}. günü saat ${hour.padStart(2, '0')}:00`;
    } else if (frequency === 'd') {
      if (schedule === '0 * * * *') {
        hourInterval = '1';
        description = 'Her saat başı';
      } else {
        hourInterval = scheduleChars[1].split('/')[1];
        description = `Her ${hourInterval} saatte bir`;
      }
    } else if (frequency === 's') {
      minuteInterval = scheduleChars[0].split('/')[1];
      if (!minuteInterval) {
        description = 'Dakikada bir';
      } else {
        description = `Her ${minuteInterval} dakikada bir`;
      }
    } else {
      frequency = 'n';
      description = 'Yok';
    }
  }

  return { frequency, day, hour, hourInterval, minuteInterval, description };
}
